import React, {useRef, useState, useEffect} from 'react'

interface CacheTimerBadgeProps {
  countdown: number
  formatCountdown: (seconds: number) => string
}

export const CacheTimerBadge: React.FC<CacheTimerBadgeProps> = ({countdown, formatCountdown}) => {
  const [showPopover, setShowPopover] = useState(false)
  const badgeRef = useRef<HTMLSpanElement>(null)
  const popoverRef = useRef<HTMLDivElement>(null)

  // Close popover when clicking outside
  useEffect(() => {
    if (!showPopover) return

    const handleClickOutside = (e: MouseEvent) => {
      if (
        badgeRef.current && !badgeRef.current.contains(e.target as Node) &&
        popoverRef.current && !popoverRef.current.contains(e.target as Node)
      ) {
        setShowPopover(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showPopover])

  return (
    <span style={{position: 'relative', display: 'inline-block'}}>
      <span
        ref={badgeRef}
        className="badge badge-light-primary fw-bold fs-7 px-3 py-2"
        style={{cursor: 'pointer'}}
        onClick={() => setShowPopover(!showPopover)}
      >
        <i className="bi bi-clock me-1"></i>
        {formatCountdown(countdown)}
      </span>

      {showPopover && (
        <div
          ref={popoverRef}
          className="card shadow-lg border"
          style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
            width: '280px',
            zIndex: 1050,
          }}
        >
          <div className="card-body p-4">
            <div className="d-flex align-items-center mb-3">
              <div className="symbol symbol-30px bg-light-primary me-3">
                <span className="symbol-label">
                  <i className="bi bi-info-circle fs-5 text-primary"></i>
                </span>
              </div>
              <span className="fw-bold fs-6 text-gray-800">Cached Data</span>
            </div>
            <p className="text-gray-600 fs-7 mb-3">
              Dashboard data is cached to keep things fast. When the timer reaches zero, click <strong>Refresh</strong> to fetch the latest data.
            </p>
            <div className="d-flex align-items-center bg-light-primary rounded p-2">
              <i className="bi bi-clock text-primary me-2"></i>
              <span className="fw-bold text-primary fs-7">
                Cache expires in {formatCountdown(countdown)}
              </span>
            </div>
          </div>
        </div>
      )}
    </span>
  )
}
